var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9993 2.6665C8.63935 2.6665 2.66602 8.63984 2.66602 15.9998C2.66602 23.3598 8.63935 29.3332 15.9993 29.3332C23.3594 29.3332 29.3327 23.3598 29.3327 15.9998C29.3327 8.63984 23.3594 2.6665 15.9993 2.6665ZM22.666 17.3332H17.3327V22.6665H14.666V17.3332H9.33268V14.6665H14.666V9.33317H17.3327V14.6665H22.666V17.3332Z",
    fill: "#304FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.50f8b0f780aa0b94f7e107791054e635.svg";
export { ForwardRef as ReactComponent };